import { connect } from 'react-redux'
import { compose } from 'redux'
import { adsUpdateItem } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import EditAd from '../present/EditAd'
import getMovieSortedByTitle from '../../../functions/getMoviesSortedByTitle'
import getData from '../../../functions/getData'
import { PROGRAM_CINEMAS, FEATURES, PROGRAM_ADS_ITEMS, PROGRAM_CLI_MOVIES_ITEMS, CLI_CINEMA_CLIENT_ID } from '../../../constants/state'
import { push } from 'connected-react-router'
import { getTranslationString } from '../../Translation/cont/Translation'

const mapStateToProps = (state, ownProps) => ({
    itemData: getData(state, [PROGRAM_ADS_ITEMS, ownProps.itemId]),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    features: getData(state, FEATURES),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    transNoMovieSelected: state.getIn(['translation', 'strings', 'content_no_movie_selected']),
    currentLang: state.getIn(['translation', 'currentLang']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(adsUpdateItem(ownProps.itemId, itemData))
        dispatch(push(ownProps.closePagePath))
    }
})

const EditAdContainer = ({itemData, onUpdateItem, movieData, cliCinemas, features, closePagePath, suffixEdit, clientCinemaId, transNoMovieSelected, currentLang}) => <EditAd 
    itemData={itemData}
    closePagePath={closePagePath}
    suffixEdit={suffixEdit}
    features={features}
    cliCinemas={cliCinemas}
    clientCinemaId={clientCinemaId}
    sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
    movieData={movieData}
    transNoMovieSelected={getTranslationString(transNoMovieSelected, currentLang)}
    onUpdateItem={onUpdateItem}
/>

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditAdContainer)